import type { SearchResult } from '@/scopes/search/search/infrastructure/api/types'

import type { IconGlyph } from '@sunwebgroup/ui-components'
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import { useFeatureFlag } from '@/scopes/common/infrastructure/feature-flags'
import { createSearchProductClickEvent } from '@/scopes/search/search/domain/analytics'
import { transformIncludedServices } from '@/scopes/search/search/domain/product-card/transformIncludedServices'
import { useSearchStore } from '@/scopes/search/search/infrastructure/store/useSearchStore'
import { ProductCard } from './ProductCard'
import { ProductCard as ProductCardLegacy } from './ProductCardLegacy'

export interface AccommodationService {
  icon?: IconGlyph
  text: string
  key: string
}

export function Result(result: SearchResult) {
  const { filterSelection } = useSearchStore()
  const { sendEvent } = useAnalytics()
  const ACTIVATE_UDS_SEARCH_PRODUCT_CARD = useFeatureFlag('ACTIVATE_UDS_SEARCH_PRODUCT_CARD')

  const onClickHandler = () => {
    sendEvent(createSearchProductClickEvent(result))
  }

  if (!ACTIVATE_UDS_SEARCH_PRODUCT_CARD) {
    return (
      <ProductCardLegacy
        accommodationId={result.id}
        accommodationServices={transformIncludedServices(result.price?.includedServices)}
        arrivalDate={result.arrivalDateDetail}
        departureDate={result.departureDateDetail}
        departureDateRaw={result.price?.acmInformation?.departureDateRaw}
        durationRaw={result.price?.acmInformation?.durationRaw}
        campaign={result.campaign}
        href={result.urlWithFilters}
        id={result.id}
        imageSources={result.images}
        isUnavailable={result.isUnavailable}
        yieldCampaign={result.price?.yieldCampaignName}
        locations={result.locations}
        mealPlan={result.featuredFilters?.mealplan}
        name={result.name ?? ''}
        partyComposition={result.featuredFilters?.occupancy}
        price={result.price?.averagePrice}
        priceDiscounts={result.price?.priceDiscounts}
        rating={result.rating ?? 0}
        transportType={result.price?.acmInformation?.transportType}
        userRating={result.userRating}
        userRatingText={result.userRatingText}
        usps={result.usps}
        outboundDepartureAirportName={result.outboundDepartureAirportName}
        collection={result.collection}
        isMarketExclusive={result.isMarketExclusive}
        isSustainable={result.isSustainable}
        participants={filterSelection?.Participants}
        onClick={onClickHandler}
      />
    )
  }

  return (
    <ProductCard
      result={result}
      participants={filterSelection?.Participants}
      onClick={onClickHandler}
    />
  )
}
